import { useEffect } from "react";
import SendIco from "../../assets/careerBuddy/send_ic.svg";
export default function ChatInput({
  text,
  setText,
  isTyping,
  isTypingAi,
  onSend,
  textareaRef,
  placeholder,
}) {
  // useEffect(() => {
  //   if (textareaRef.current && !(isTypingAi || isTyping)) {
  //     textareaRef.current.focus();
  //   }
  // }, [isTypingAi, isTyping, textareaRef]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!(isTypingAi || isTyping)) {
        onSend(e);
      }
    }
  };

  const handleInput = (event) => {
    const textarea = event.target;
    textarea.style.height = "45px"; // Reset height
    const newHeight = Math.min(textarea.scrollHeight, 200); // Max height 200px
    textarea.style.height = `${newHeight}px`;
  };

  return (
    <div>
      <form className="CareerCont__chatbot__input">
        <textarea
          ref={textareaRef}
          disabled={isTypingAi || isTyping}
          onInput={handleInput}
          value={text}
          onKeyDown={handleKeyDown}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
        />
        {!(isTypingAi || isTyping) && (
          <button onClick={onSend}>
            <img src={SendIco} className="send_ico" alt="send" />
          </button>
        )}
      </form>
      <p className="aiCompanions__chat__note CareerCont__chatbot__guide">
        AI Companions may make mistakes. Please verify key information or
        consult a trusted professional.
      </p>
    </div>
  );
}
